import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DateTime } from 'luxon';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { StudentsClient } from 'src/app/generated-client/generated-api-client';
import { ErrorProcessorService } from '../../../services/error-processor.service';

export interface ExamDateShiftConfirmModal {
  title: string;
  studentId: string;
  date?: DateTime;
  subjectId?: string;
}

interface ExamShiftedDate {
  examSubject: string;
  originalDate: DateTime;
  shiftedDate: DateTime;
}

@Component({
  selector: 'app-exam-date-shift-confirm-modal',
  templateUrl: './exam-date-shift-confirm-modal.component.html',
  styleUrls: ['./exam-date-shift-confirm-modal.component.sass'],
})
export class ExamDateShiftConfirmModalComponent
  extends SimpleModalComponent<ExamDateShiftConfirmModal, boolean>
  implements ExamDateShiftConfirmModal, OnInit
{
  title!: string;
  studentId!: string;
  date?: DateTime;
  subjectId?: string;
  shiftedDates?: ExamShiftedDate[];

  @Output() onShiftDates: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private _studentsClient: StudentsClient, private errorProcessorService: ErrorProcessorService) {
    super();
  }

  shiftDates(result: boolean) {
    this.result = result;
    this.close();
    this.onShiftDates.emit(this.result);
  }

  hasChange(date: ExamShiftedDate) : boolean{
    return date.originalDate.toISO() !== date.shiftedDate.toISO();
  }

  ngOnInit() {
    this._studentsClient.shiftedTimes(this.studentId, this.date, this.subjectId).subscribe(
      next => {
        const dates: ExamShiftedDate[] = next.shiftedDates!.map(x => {
          return {
            examSubject: x.examSubject!,
            originalDate: DateTime.fromISO(x.originalDate as unknown as string),
            shiftedDate: DateTime.fromISO(x.shiftedDate as unknown as string),
          };
        });
        this.shiftedDates = dates;
      },
      error => this.errorProcessorService.processError(error)
    );
  }
}
